import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";

import { Button } from "../../../components/Button";
import { InlineAlert } from "../../../components/InlineAlert";
import { PageFooterWrapper } from "../../../components/PageFooterWrapper";
import { TextButton } from "../../../components/TextButton";
import {
  type FooterActionCallbacks,
  type FooterDataProps,
  getFooterContent,
} from "./utils/getFooterContent";

interface PastShiftDetailsFooterProps extends FooterDataProps {
  actions: FooterActionCallbacks;
}

export function PastShiftDetailsFooter(props: PastShiftDetailsFooterProps) {
  const { actions, ...footerDataProps } = props;

  const content = getFooterContent(footerDataProps, actions);

  if (!isDefined(content)) {
    return null;
  }

  return (
    <PageFooterWrapper withShadow sx={content.wrapperSx}>
      <Stack spacing={4} alignItems="center">
        {isDefined(content.alertTitle) && (
          <InlineAlert
            iconType="triangle-exclamation"
            iconColor={(theme) => theme.palette.intent?.error.text}
            title={content.alertTitle}
            titleColor={(theme) => theme.palette.intent?.error.text}
            description={content.description}
            descriptionVariant={content.descriptionVariant}
          />
        )}

        {!isDefined(content.alertTitle) && (
          <Text
            semibold
            variant={content.descriptionVariant}
            align="center"
            sx={{ color: "text.secondary" }}
          >
            {content.description}
          </Text>
        )}

        <Button
          fullWidth
          disabled={content.primaryButtonDisabled}
          variant={content.primaryButtonVariant}
          size="large"
          startIconType={content.primaryButtonStartIconType}
          onClick={content.primaryButtonAction}
        >
          {content.primaryButtonLabel}
        </Button>

        {isDefined(content.secondaryButtonLabel) && isDefined(content.secondaryButtonAction) && (
          <TextButton size="medium" onClick={content.secondaryButtonAction}>
            {content.secondaryButtonLabel}
          </TextButton>
        )}
      </Stack>
    </PageFooterWrapper>
  );
}
